import styled from 'styled-components';

const DeltaIcon = styled.span`
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 0px;
    padding-right: 5px;
    font-size: 15px;
`;

export default DeltaIcon;



// WEBPACK FOOTER //
// ./src/components/atoms/callout/DeltaIcon.js